/**
 * Gift Selector (v8)
 *
 * - Error if no gift selected
 * - 1 gift per order: checks cart first, skips if gift already exists
 * - Opens cart drawer after adding
 */
(function () {
  'use strict';

  function init() {
    var giftSelector = document.querySelector('[data-gift-selector]');
    if (!giftSelector) return;

    var giftInput = giftSelector.querySelector('[data-gift-variant-input]');
    if (!giftInput) return;

    var giftError = giftSelector.querySelector('[data-gift-error]');

    var productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!productForm) return;

    var submitBtn = productForm.querySelector('[name="add"]');
    if (!submitBtn) return;

    submitBtn.addEventListener(
      'click',
      function (e) {
        var giftVariantId = giftInput.value;

        if (!giftVariantId) {
          e.preventDefault();
          e.stopImmediatePropagation();

          if (giftError) giftError.removeAttribute('hidden');
          giftSelector.classList.remove('gift-selector--shake');
          void giftSelector.offsetWidth;
          giftSelector.classList.add('gift-selector--shake');
          giftSelector.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        if (giftError) giftError.setAttribute('hidden', '');

        var mainInput = productForm.querySelector('input.product-variant-id, input[name="id"]');
        if (!mainInput || !mainInput.value) return;

        var mainVariantId = parseInt(mainInput.value, 10);
        var giftId = parseInt(giftVariantId, 10);
        var qtyInput = productForm.querySelector('[name="quantity"]');
        var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

        setLoading(submitBtn, true);

        // Check if gift already in cart
        xhrGet('/cart.js', function (cart) {
          var giftExists = false;

          if (cart && cart.items) {
            for (var i = 0; i < cart.items.length; i++) {
              var p = cart.items[i].properties || {};
              if (p['_gift_with'] === 'true' || p['_gift_with'] === true) {
                giftExists = true;
                break;
              }
            }
          }

          var items = [{ id: mainVariantId, quantity: quantity }];
          if (!giftExists) {
            items.push({ id: giftId, quantity: 1, properties: { '_gift_with': 'true' } });
          }

          xhrPost('/cart/add.js', { items: items }, function (ok, err) {
            if (ok) {
              refreshAndOpenDrawer();
            } else {
              showError(productForm, err || 'Could not add to cart');
            }
            setLoading(submitBtn, false);
          });
        });
      },
      true
    );
  }

  // ── XHR helpers ─────────────────────────────────────────────
  function xhrGet(url, cb) {
    var x = new XMLHttpRequest();
    x.open('GET', url, true);
    x.setRequestHeader('Accept', 'application/json');
    x.onreadystatechange = function () {
      if (x.readyState === 4) {
        try { cb(x.status === 200 ? JSON.parse(x.responseText) : null); }
        catch (e) { cb(null); }
      }
    };
    x.send();
  }

  function xhrPost(url, data, cb) {
    var x = new XMLHttpRequest();
    x.open('POST', url, true);
    x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('Accept', 'application/json');
    x.onreadystatechange = function () {
      if (x.readyState === 4) {
        if (x.status >= 200 && x.status < 300) { cb(true); }
        else {
          var msg = '';
          try { msg = JSON.parse(x.responseText).description || ''; } catch (e) {}
          cb(false, msg);
        }
      }
    };
    x.send(JSON.stringify(data));
  }

  // ── Drawer ──────────────────────────────────────────────────
  function refreshAndOpenDrawer() {
    var el = document.getElementById('shopify-section-cart-drawer');
    if (!el) { openDrawer(); return; }

    xhrGet('/?sections=cart-drawer', function (sections) {
      if (sections && sections['cart-drawer']) {
        el.innerHTML = new DOMParser()
          .parseFromString(sections['cart-drawer'], 'text/html').body.innerHTML;
      }
      updateCount(function () { openDrawer(); });
    });
  }

  function openDrawer() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); return; }
    if (d) {
      d.classList.add('active', 'is-open');
      d.removeAttribute('hidden');
      document.body.classList.add('overflow-hidden');
      return;
    }
    var t = document.querySelector('.header__icon--cart, [data-cart-trigger], button[aria-controls*="cart"]');
    if (t) t.click();
  }

  function updateCount(cb) {
    xhrGet('/cart.js', function (cart) {
      if (cart) {
        ['.cart-count-bubble span', '[data-cart-count]', '.cart-count', '#cart-icon-bubble span']
          .forEach(function (s) {
            document.querySelectorAll(s).forEach(function (el) { el.textContent = cart.item_count; });
          });
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          if (cart.item_count > 0) { el.removeAttribute('hidden'); el.style.display = ''; }
        });
      }
      if (cb) cb();
    });
  }

  // ── UI helpers ──────────────────────────────────────────────
  function setLoading(btn, on) {
    var sp = btn.querySelector('span'), ld = btn.querySelector('.loading-overlay__spinner');
    if (on) { btn.disabled = true; if (sp) sp.style.visibility = 'hidden'; if (ld) ld.classList.remove('hidden'); }
    else { btn.disabled = false; if (sp) sp.style.visibility = 'visible'; if (ld) ld.classList.add('hidden'); }
  }

  function showError(form, msg) {
    var w = form.querySelector('.product-form__error-message-wrapper');
    var m = form.querySelector('.product-form__error-message');
    if (w && m) { m.textContent = msg; w.removeAttribute('hidden'); setTimeout(function () { w.setAttribute('hidden', ''); }, 5000); }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();